import React from 'react'

const ContactUs = ({ productInfo }) => {
    return (
        <>
            <h3 class="serviceName">{productInfo?.contact_us?.title}</h3>
            <p>
                Contact Cleer Customer Support for tailored products suited for your company’s needs.
            </p>
            <div class="purchase_btn_wrapper">
                <a class="nextBtn purchase_btn" href={productInfo?.contact_us?.sendTo}
                    target="_blank"
                >
                    Contact Us
                </a>

            </div>
        </>
    )
}

export default ContactUs